import React from "react";
import Subscriber from "../../subscriber.class";
import SmartBanner from "../../Modules/SmartBanner/SmartBanner";
import CartButton from "./CartButton";
import red_logo from "../../assets/img/new_onboarding/virgin-mobile-logo.svg";
import white_logo from "../../assets/img/new_onboarding/atoms-logo-white.svg";
import Settings from "../../services/settings";
import Storage from "../../services/storage.service";

export default class Header extends Subscriber {

  state = {
    header_visible: true
  }

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("modal_open").subscribe((modal_type) => {
        this.setState({
          header_visible: modal_type !== "full-mobile"
        });
      })
    );
  }

  render() {
    if(!this.state.header_visible){
      return "";
    }
    
    let logo = <img alt="" className="vmo-blink" src={white_logo} />;
    if (this.props.variation === "vmo-plain-header") {
      logo = <img alt="" className="vmo-blink" src={red_logo} />;
    }

    return (
      <div className="vmo-header-wrapper">
        {Settings.enable_smart_banner ? <SmartBanner /> : ""}
        <div className="vmo-header">
          <div className="vmo-centered-max vmo-header-padded">
            <div className="vmo-header-flex">
              <div className="vmo-brand-logo vmo-header-flex-1">
                <a href={Settings.logo_link}>{logo}</a>
              </div>
              <div className="vmo-header-flex-2">
                <CartButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
